export const html = `<!DOCTYPE html>
<html>
<head>
    <title>Receipt</title>
    <meta charset="UTF-8">
    <style>
div {
  padding: 5px;
  height: 600px;
  width: 850px;
  background-color: #ffffff;
}
table {
  font-family: arial, sans-serif;
  font-size: 15px;
  border-collapse: collapse;
  width: 100%;
}
th#t01 {
  color: black;
  background-color: #ffe74c;
  border: 1px solid #ffe74c;
  text-align: center;
}
th#t02 {
  color: black;
  background-color: #dedede;
  border: 1px solid #dedede;
}
th#t03 {
  color: black;
  background-color: #ccccff;
  border: 1px solid #ccccff;
}
th#t04 {
  color: black;
  background-color: #b2ffb2;
  border: 1px solid #b2ffb2;
}
th#t05 {
  color: black;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  padding: 1px;
}
th#t06 {
  background-color: #ffffff;
  border: 1px solid #ffffff;
  padding: 5px;
}
td, th {
border: 1px solid #bebebe;
  text-align: left;
  padding: 8px;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
table { table-layout: fixed; }
td { width: 33%; }
@media print {
    * {
    -webkit-print-color-adjust: exact;
    }
}
    </style>
</head>
<body>
<div class="center">
    <img src="_logo" class="center">
    <table>
        <tr>
            <th id="t06"></th>
        </tr>
        <tr>
            <th id="t01">Recharge Transaction Receipt</th>
        </tr>
        <tr>
            <th id="t06"></th>
        </tr>
        <tr>
            <th id="t05">_payer_name</th>
        </tr>
        <tr>
            <th id="t02">Recharge Details</th>
        </tr>
    </table>
    <table>
        <tr>
            <th>Operator</th>
            <th>Recharge Number</th>
            <th>Name</th>
            <th>Recharge Date</th>
        </tr>
        <tr>
            <td>_service</td>
            <td>_rechargemobileno</td>
            <td>_payer_name</td>
            <td>_recharge_date</td>
        </tr>
    </table>
    <table>
     
        <tr>
            <th>Recharge ID</th>
            <th>Recharge Amount</th>
            <th>Recharge Status</th>
            
        </tr>
        <tr>
            <td>_qrcode_txid</td>
            <td>_rechargemobileno</td>
            <td>_amount</td>
            
        </tr>
    </table>
    <table>
        <tr>
            <th id="t06"></th>
        </tr>
        <tr>
            <th id="t03">Bank Transaction Details</th>
        </tr>
    </table>
    <table>
        <tr>
            <th>From</th>
            <th>Bank Ref.No</th>
            <th>Payment Date</th>
             <th>Payment Amount</th>
            <th>Payment Status</th>
            
           
        </tr>
        <tr>
            <td>_payer_vpa</td>
            <td>_bank_rrn</td>
            <td>_payment_date</td>
             <td>_total</td>           
            <td>_payment_status</td>
             
        </tr>
    </table>

   
    <table>
        <tr>
            <th id="t06"></th>
        </tr>
        <tr>
            <th id="t04">Sender Details</th>
        </tr>
    </table>
    <table>
        <tr>
            <td>UserName</td>
            <td>MobileNo</td>
        </tr>
    </table>
    <p style="color:#ff0000;font-size: 15px;">* This is a computer generated receipt hence does not require any
        signature.</p>
</div>
</body>
</html>`;
